import * as tylerStandardIcons from "@tylertech/tyler-icons/standard";
import * as tylerExtendedIcons from "@tylertech/tyler-icons/extended";
import * as tylerCustomIcons from "@tylertech/tyler-icons/custom";

import { IconRegistry } from "@tylertech/forge";

IconRegistry.define([
    /* Standard Icons */
    tylerStandardIcons.tylIconAccessTime,
    tylerStandardIcons.tylIconAdd,
    tylerStandardIcons.tylIconMenu,
    tylerStandardIcons.tylIconReceipt,
    tylerStandardIcons.tylIconList,
    tylerStandardIcons.tylIconEventNote,
    tylerStandardIcons.tylIconPlaylistAddCheck,
    tylerStandardIcons.tylIconAttachFile,
    tylerStandardIcons.tylIconDelete,
    tylerStandardIcons.tylIconCompareArrows,
    tylerStandardIcons.tylIconShuffle,
    tylerStandardIcons.tylIconDeleteSweep,
    tylerStandardIcons.tylIconPlaylistAdd,
    tylerStandardIcons.tylIconWrapText,
    tylerStandardIcons.tylIconAccountBalanceWallet,
    tylerStandardIcons.tylIconEdit,
    tylerStandardIcons.tylIconArchive,
    tylerStandardIcons.tylIconPrint,
    tylerStandardIcons.tylIconPublish,
    tylerStandardIcons.tylIconCollectionsBookmark,
    tylerStandardIcons.tylIconHelp,
    tylerStandardIcons.tylIconHelpOutline,
    tylerStandardIcons.tylIconChat,
    tylerStandardIcons.tylIconSearch,
    tylerStandardIcons.tylIconPeople,
    tylerStandardIcons.tylIconApps,
    tylerStandardIcons.tylIconArrowBack,
    tylerStandardIcons.tylIconArrowForward,
    tylerStandardIcons.tylIconMonetizationOn,
    tylerStandardIcons.tylIconCreditCard,
    tylerStandardIcons.tylIconAttachment,
    tylerStandardIcons.tylIconDescription,
    tylerStandardIcons.tylIconInsertChartOutlined,
    tylerStandardIcons.tylIconAssignmentInd,
    tylerStandardIcons.tylIconInventory,
    tylerStandardIcons.tylIconListAlt,
    tylerStandardIcons.tylIconFolderSpecial,
    tylerStandardIcons.tylIconMoveToInbox,
    tylerStandardIcons.tylIconAssignment,
    tylerStandardIcons.tylIconStoreMallDirectory,
    tylerStandardIcons.tylIconSimCardAlert,
    tylerStandardIcons.tylIconErrorOutline,
    tylerStandardIcons.tylIconReceiptLong,
    tylerStandardIcons.tylIconAddBox,
    tylerStandardIcons.tylIconSwapVert,
    tylerStandardIcons.tylIconRestorePage,
    tylerStandardIcons.tylIconDone,
    tylerStandardIcons.tylIconBuild,
    tylerStandardIcons.tylIconAttachMoney,
    tylerStandardIcons.tylIconPostAdd,
    tylerStandardIcons.tylIconWatchLater,
    tylerStandardIcons.tylIconFormatListNumbered,
    tylerStandardIcons.tylIconNoteAdd,
    tylerStandardIcons.tylIconOpenInNew,
    tylerStandardIcons.tylIconSettings,
    tylerStandardIcons.tylIconCheckCircle,
    tylerStandardIcons.tylIconLens,
    tylerStandardIcons.tylIconHowToReg,
    tylerStandardIcons.tylIconBlock,
    tylerStandardIcons.tylIconDoneAll,
    tylerStandardIcons.tylIconCheck,
    tylerStandardIcons.tylIconBugReport,
    tylerStandardIcons.tylIconDeleteForever,
    tylerStandardIcons.tylIconTimer,
    tylerStandardIcons.tylIconWarning,
    tylerStandardIcons.tylIconLock,
    tylerStandardIcons.tylIconContacts,
    tylerStandardIcons.tylIconAssignmentTurnedIn,
    tylerStandardIcons.tylIconAccountBalance,
    tylerStandardIcons.tylIconMoneyOff,
    tylerStandardIcons.tylIconForward30,
    tylerStandardIcons.tylIconFlightLand,
    tylerStandardIcons.tylIconFlightTakeoff,
    tylerStandardIcons.tylIconPermContactCalendar,
    tylerStandardIcons.tylIconFitnessCenter,
    tylerStandardIcons.tylIconSchedule,
    tylerStandardIcons.tylIconDeveloperBoard,
    tylerStandardIcons.tylIconAccountCircle,
    tylerStandardIcons.tylIconStar,
    tylerStandardIcons.tylIconWhatshot,
    tylerStandardIcons.tylIconDiscFull,
    tylerStandardIcons.tylIconPerson,
    tylerStandardIcons.tylIconCancel,
    tylerStandardIcons.tylIconAutorenew,
    tylerStandardIcons.tylIconRestore,
    tylerStandardIcons.tylIconReport,
    tylerStandardIcons.tylIconPersonOutline,
    tylerStandardIcons.tylIconNotifications,
    tylerStandardIcons.tylIconInfoOutline,
    tylerStandardIcons.tylIconSchool,
    tylerStandardIcons.tylIconGroupWork,
    tylerStandardIcons.tylIconLocalHospital,
    tylerStandardIcons.tylIconTrendingUp,
    tylerStandardIcons.tylIconAddCircle,
    tylerStandardIcons.tylIconRemoveCircle,
    tylerStandardIcons.tylIconError,
    tylerStandardIcons.tylIconNotificationsActive,
    tylerStandardIcons.tylIconNotificationsNone,
    tylerStandardIcons.tylIconToday,
    tylerStandardIcons.tylIconShoppingCart,
    tylerStandardIcons.tylIconFindInPage,
    tylerStandardIcons.tylIconShare,
    tylerStandardIcons.tylIconNotInterested,
    tylerStandardIcons.tylIconDragIndicator,
    tylerStandardIcons.tylIconClose,
    tylerStandardIcons.tylIconMoreVert,
    tylerStandardIcons.tylIconBolt,
    tylerStandardIcons.tylIconChatBubbleOutline,
    tylerStandardIcons.tylIconImportExport,
    tylerStandardIcons.tylIconVisibility,
    tylerStandardIcons.tylIconVisibilityOff,
    tylerStandardIcons.tylIconGridView,
    tylerStandardIcons.tylIconKeyboardArrowRight,
    tylerStandardIcons.tylIconKeyboardArrowLeft,
    tylerStandardIcons.tylIconKeyboardArrowDown,
    tylerStandardIcons.tylIconKeyboardArrowUp,
    tylerStandardIcons.tylIconArrowDropDown,
    tylerStandardIcons.tylIconRotateLeft,
    tylerStandardIcons.tylIconReplay,
    tylerStandardIcons.tylIconDoNotDisturbAlt,
    tylerStandardIcons.tylIconLockOpen,
    tylerStandardIcons.tylIconOfflinePin,
    tylerStandardIcons.tylIconMailOutline,
    tylerStandardIcons.tylIconUndo,
    tylerStandardIcons.tylIconPageview,
    tylerStandardIcons.tylIconPlayArrow,
    tylerStandardIcons.tylIconStop,
    tylerStandardIcons.tylIconSearch,
    tylerStandardIcons.tylIconPayment,
    tylerStandardIcons.tylIconOpenInBrowser,
    tylerStandardIcons.tylIconApproval,
    tylerStandardIcons.tylIconDoneOutline,
    tylerStandardIcons.tylIconChevronLeft,
    tylerStandardIcons.tylIconChevronRight,
    tylerStandardIcons.tylIconPieChart,
    tylerStandardIcons.tylIconSync,
    tylerStandardIcons.tylIconContentCopy,
    tylerStandardIcons.tylIconPowerOff,
    tylerStandardIcons.tylIconRefresh,
    tylerStandardIcons.tylIconPhoneIphone,
    tylerStandardIcons.tylIconExpand,
    tylerStandardIcons.tylIconFilterAlt,
    tylerStandardIcons.tylIconCheckBox,
    tylerStandardIcons.tylIconCheckBoxOutlineBlank,
    tylerStandardIcons.tylIconInput,
    tylerStandardIcons.tylIconFilterList,
    tylerStandardIcons.tylIconViewStream,
    tylerStandardIcons.tylIconLastPage,
    tylerStandardIcons.tylIconFirstPage,
    tylerStandardIcons.tylIconArrowUpward,
    tylerStandardIcons.tylIconArrowDownward,
    tylerStandardIcons.tylIconGridOn,
    tylerStandardIcons.tylIconCenterFocusStrong,
    tylerStandardIcons.tylIconUpdate,
    tylerStandardIcons.tylIconHome,
    tylerStandardIcons.tylIconFormatIndentIncrease,
    tylerStandardIcons.tylIconSend,
    tylerStandardIcons.tylIconLibraryBooks,
    tylerStandardIcons.tylIconNaturePeople,
    tylerStandardIcons.tylIconMap,
    tylerStandardIcons.tylIconFormatPaint,
    tylerStandardIcons.tylIconPolicy,
    tylerStandardIcons.tylIconDomain,
    tylerStandardIcons.tylIconImage,
    tylerStandardIcons.tylIconBookmark,
    tylerStandardIcons.tylIconBookmarkBorder,
    tylerStandardIcons.tylIconRadioButtonUnchecked,
    tylerStandardIcons.tylIconRemove,
    tylerStandardIcons.tylIconHistory,
    tylerStandardIcons.tylIconHistoryToggleOff,
    tylerStandardIcons.tylIconFileUpload,
    tylerStandardIcons.tylIconAddShoppingCart,
    tylerStandardIcons.tylIconCheckCircleOutline,
    tylerStandardIcons.tylIconCrop,
    tylerStandardIcons.tylIconFileDownload,

    /* Extended Icons */
    tylerExtendedIcons.tylIconAccount,
    tylerExtendedIcons.tylIconBookmarkOff,
    tylerExtendedIcons.tylIconSortAscending,
    tylerExtendedIcons.tylIconSortDescending,
    tylerExtendedIcons.tylIconCalendarClockOutline,
    tylerExtendedIcons.tylIconClipboardClockOutline,
    tylerExtendedIcons.tylIconCashCheck,
    tylerExtendedIcons.tylIconTransfer,
    tylerExtendedIcons.tylIconFileImport,
    tylerExtendedIcons.tylIconSwapHorizontalCircleOutline,
    tylerExtendedIcons.tylIconAccountCash,
    tylerExtendedIcons.tylIconBankPlus,
    tylerExtendedIcons.tylIconBriefcaseClock,
    tylerExtendedIcons.tylIconCreditCardClock,
    tylerExtendedIcons.tylIconBusSchool,
    tylerExtendedIcons.tylIconFormatListChecks,
    tylerExtendedIcons.tylIconCheckbook,
    tylerExtendedIcons.tylIconOfficeBuilding,
    tylerExtendedIcons.tylIconFilePercentOutline,
    tylerExtendedIcons.tylIconClipboardTextOutline,
    tylerExtendedIcons.tylIconChevronDown,
    tylerExtendedIcons.tylIconChevronUp,
    tylerExtendedIcons.tylIconChevronDoubleDown,
    tylerExtendedIcons.tylIconChevronDoubleUp,
    tylerExtendedIcons.tylIconSignalCellular2,
    tylerExtendedIcons.tylIconCalendarClock,
    tylerExtendedIcons.tylIconAlertOctagram,
    tylerExtendedIcons.tylIconPrinterCheck,
    tylerExtendedIcons.tylIconTruck,
    tylerExtendedIcons.tylIconDoNotDisturb,
    tylerExtendedIcons.tylIconWater,
    tylerExtendedIcons.tylIconPipe,
    tylerExtendedIcons.tylIconAlertOutline,
    //tylerExtendedIcons.tylIconFileDownload,
    tylerExtendedIcons.tylIconPin,
    tylerExtendedIcons.tylIconPinOff,
    tylerExtendedIcons.tylIconTableSettings,
    tylerExtendedIcons.tylIconDownload,
    tylerExtendedIcons.tylIconUpload,
    tylerExtendedIcons.tylIconBullhorn,
    tylerExtendedIcons.tylIconEyeOutline,
    tylerExtendedIcons.tylIconFilterRemove,
    tylerExtendedIcons.tylIconPercent,
    tylerExtendedIcons.tylIconFormSelect,
    tylerExtendedIcons.tylIconMathCompass,
    tylerExtendedIcons.tylIconChevronDoubleRight,
    tylerExtendedIcons.tylIconChevronDoubleLeft,
    tylerExtendedIcons.tylIconHelpBox,
    tylerExtendedIcons.tylIconAlertCircleOutline,
    tylerExtendedIcons.tylIconSchool,
    tylerExtendedIcons.tylIconProgressCheck,
    tylerExtendedIcons.tylIconArrowCollapseVertical,
    tylerExtendedIcons.tylIconCheckboxMultipleBlankOutline,
    tylerExtendedIcons.tylIconCheckboxMultipleMarked,
    tylerExtendedIcons.tylIconFileEyeOutline,
    tylerExtendedIcons.tylIconPlayOutline,
    tylerExtendedIcons.tylIconStopCircleOutline,
    tylerExtendedIcons.tylIconCalculator,
    tylerExtendedIcons.tylIconClockOutline,
    tylerExtendedIcons.tylIconInboxArrowUp,
    tylerExtendedIcons.tylIconBookOpenVariant,
    tylerExtendedIcons.tylIconJira,
    tylerExtendedIcons.tylIconCardAccountDetailsOutline,
    tylerExtendedIcons.tylIconVote,
    tylerExtendedIcons.tylIconAccountMultiple,
    tylerExtendedIcons.tylIconPackageVariant,
    tylerExtendedIcons.tylIconInboxArrowDown,
    tylerExtendedIcons.tylIconFormatListCheckbox,
    tylerExtendedIcons.tylIconTools,
    tylerExtendedIcons.tylIconWrench,
    tylerExtendedIcons.tylIconPinOutline,
    tylerExtendedIcons.tylIconPinOffOutline,
    tylerExtendedIcons.tylIconNoteTextOutline,
    tylerExtendedIcons.tylIconVectorLink,
    tylerExtendedIcons.tylIconNote,
    tylerExtendedIcons.tylIconWizardHat,
    tylerExtendedIcons.tylIconCalendarBlank,
    tylerExtendedIcons.tylIconCalendarPlus,
    tylerExtendedIcons.tylIconCalendarRemoveOutline,
    tylerExtendedIcons.tylIconAccountPlus,
    tylerExtendedIcons.tylIconTextBoxCheckOutline,
    tylerExtendedIcons.tylIconAccountRemove,
    tylerExtendedIcons.tylIconAccessPoint,
    tylerExtendedIcons.tylIconCircle,
    tylerExtendedIcons.tylIconCircleHalfFull,
    tylerExtendedIcons.tylIconCircleOutline,
    tylerExtendedIcons.tylIconEye,
    tylerExtendedIcons.tylIconHammer,
    tylerExtendedIcons.tylIconChartBar,
    tylerExtendedIcons.tylIconTooltipText,
    tylerExtendedIcons.tylIconMenuOpen,
    tylerExtendedIcons.tylIconRepeat,
    /* Custom Icons */
    tylerCustomIcons.tylIconExport,
    tylerCustomIcons.tylIconImport,
    tylerCustomIcons.tylIconTylerCoachAccountInfo,
    tylerCustomIcons.tylIconTylerTalkingTLogo
]);
